<template>
    <form id="mainEditForm" action="#"  @submit.prevent="saveOrder">

        <q-modal v-model="editOrder"  maximized @escape-key='unlockOrder'>

              
            <q-modal-layout>
                <q-toolbar slot="header">
                <q-toolbar-title>
                    Редактирование заказа
                </q-toolbar-title>

                <q-btn
                    color="negative"
                    label="Отмена"
                    icon = "cancel"
                    wait-for-ripple
                    @click="cancelEdit"
                    style="margin-right: 20px;"
                />
                
                <q-btn
                    color="green"
                    label="Сохранить"
                    icon = "save"
                    wait-for-ripple
                    type="submit"
                    :disable = "saveBlock"
                    @click = 'saveOrder'
                />
                
                </q-toolbar>

                <div class="layout-padding" style="align-items: center;">

                    <div style="width:450px; align-items: center;">
                        <q-select
                            name = "manager_field"
                            v-model="newOrderData.manager"
                            float-label="Менеджер заказа"
                            placeholder ="Выберите менеджера заказа"
                            filter
                            autofocus-filter
                            filter-placeholder = "Фильтр"
                            :options="getManagers"
                            style="margin-bottom:25px"
                            separator
                            v-validate="{required : true}"
                            v-bind:class="{ error_input: errors.has('manager_field')}"
                        />
                        <span v-show="errors.has('manager_field')" style="color:red">{{ errors.first('manager_field') }}</span>
                       
                       <div class='row no-wrap ellipsis items-baseline full-width justify-between'>

                            <q-select
                                name = "contragent_field"
                                v-model="newOrderData.contragent"
                                float-label="Заказчик"
                                filter
                                autofocus-filter
                                filter-placeholder = "Фильтр"
                                placeholder ="Выберите заказчика"
                                :options="getContragents"
                                style="margin-bottom:25px; width:100%"
                                separator
                                v-validate="{required : true}"
                            />
                            <span style="color:red">{{ errors.first('contragent_field') }}</span>

                            <div>
                                <q-btn outline size='sm' color='primary' icon="far fa-address-book" class='q-ml-lg' @click='addNewContragent'>
                                    <q-tooltip :delay="1000">
                                        Создать нового контрагента
                                    </q-tooltip>
                                </q-btn>
                            </div>
                            

                           

                        </div>

                        <q-input v-model="newOrderData.comment" float-label="Комментарии к заказу" name="comment_list" style="margin-bottom:25px"/>

                        <q-input v-model="newOrderData.path" float-label="Путь к исходным файлам" name="path_list" />
                       
                    </div>
                    
                    <upload></upload>
                    
                </div>
            </q-modal-layout>
        </q-modal>
        <!-- <addContragentDialog/> -->
    </form>
</template>
<script>

/* eslint-disable */
import upload from './upload';
// import addContragentDialog from './../contragents/contragentEditDialog';


export default {

  name:'DesignerDialog',
  
  data () {
            return {
                editOrder: false, 
                orderId : 0,  
                saveBlock : false, //флаг блокировки дублирования сохранения
                newOrderData : {
                    id : 0,
                    manager : null,
                    contragent : null,
                    fileCloud : 0,
                    comment : '',
                    path : '',
                    previews : []
                },
                files : [],
            }
  },

  components :{
      upload,
    //   addContragentDialog,
  },
 
  created() {

      eventBus.$on('editOrder', (order)=>{
        eventBus.$emit('clearPreview');
         if ( order != undefined ) {
             this.orderId = order.id;
             this.newOrderData.contragent = order.contragent;
             this.newOrderData.manager = order.manager;
             this.newOrderData.comment = order.comment;
             this.newOrderData.path = order.path;
             this.newOrderData.id = order.id;
         }
         this.editOrder = true;
      });

      eventBus.$on('createNewOrder', () =>{
          this.editOrder = true;
      });

      //нужно проверить загрузку постобработки

      if (this.$store.getters.getAllPostTypes.length == 0) { // если список пуст - то пробуем загрузить
        this.$store.dispatch('getPostTypes');
      } 
      
  },
  
  beforeDestroy() {
      eventBus.$off('editOrder');
      eventBus.$off('createNewOrder');
  },

  computed: {

      
      getContragents() {
          var list = [];
          if (this.$store.getters.allContragents==undefined) return list;
          this.$store.getters.allContragents.map((value,key)=>{
              list.push({label:value.name, value:value.id});
          });
          return list;

      },

      getManagers() {
          var list = [];
          if (this.$store.getters.allUsers==undefined) return list;
          this.$store.getters.allUsers.map((value,key)=>{
              
              //проверяем роли - добавляем в список только тех, у которых права менеджера или администратор

               if ((value.roles.findIndex(item=>{return item==1})>-1)||(value.roles.findIndex(item => {return item == 2})>-1))
                    list.push({label:value.name+" "+value.surname, value:value.id});
                    
          });
          return list;
      }


  },

  methods : {

        addNewContragent() {
            eventBus.$emit('openContragentEditDialog', -1);
        },

        unlockOrder(){

            this.$store.dispatch('unlockOrder',  this.orderId)
            .then()
            .catch(error => {
                this.$admns.showNotify('Не удалось разблокировать запись','error','Сообщение системы');
                console.log(error);
            });

        },

      
      setEmptyData() {
          this.newOrderData.manager = null;
          this.newOrderData.contragent = null;
          this.newOrderData.comment = '';
          this.newOrderData.path = '';
          this.newOrderData.id = 0;

          eventBus.$emit('clearPreview'); // удаляем все превью
      },

      showNotify(nMessage, nType, detail='') {

          this.$admns.showNotify(nMessage, nType, detail);

      },


      saveOrder() {
        if (this.saveBlock) return; // значит дублирование сохранения
        this.$validator.validateAll().then( (result) => {
                if (result) {
                    this.saveBlock = true;

                    //проверяем на наличие файлов для загрузки в облако - если они есть - значит ставим флаг
                    if (this.$store.getters.needToCloudUpload) {
                        this.newOrderData.fileCloud = 1;
                    }

                    this.$store.dispatch('updateOrder', this.newOrderData
                    )
                    .then( () => {
                        this.showNotify('Параметры заказа сохранены', 'success')    
                        this.setEmptyData();
                        this.editOrder = false;
                        this.saveBlock = false;
                        this.unlockOrder();
                    })
                    .catch(error => {
                        console.log(error);
                        this.saveBlock = false;
                    });
                }
          })
          .catch((result)=>{
              console.log(result);
          });
      },

      cancelEdit() {
          this.editOrder = false;
          this.setEmptyData();
          this.unlockOrder();
          this.showNotify('Отмена редактирования заказа', 'error', 'Отменено пользователем')
      }
  },
  
  

}
</script>

<style lang="scss" scoped>
    .param-container {
        width:350px;
    }
    .drop-container {
        margin-top : 35px;
        padding-top : 130px;
        width : 90%;
        height : 300px;
        border : 1px dashed darkgray;
        font-size : 15px;
        color:darkgray;
        text-align: center;
        align-items: center;
    }
</style>
